import Vue from 'vue'
import App from './App.vue'
import router from './router' 
import Icon from '@/components/Icon'
import 'element-ui/lib/theme-chalk/index.css'
// import Vconsole from 'vconsole';

import { Message, Popover, Tooltip, } from 'element-ui' 
 
const request = require.context('./assets/svg', true, /\.svg$/) 
// const vConsole =new Vconsole();
// Vue.use(vConsole);

request.keys().forEach(request)
// console.log({request})
// console.log('request.id', request.id)
// console.log('request.keys', request.keys()) 

Vue.config.productionTip = false

 
Vue.use(Popover)
Vue.use(Tooltip)
Vue.component(Message.name, Message)
Vue.component('icon', Icon) 

Vue.prototype.$message = Message

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');